import { render, staticRenderFns } from "./module-skeleton.vue?vue&type=template&id=2e7f7d9e&scoped=true&"
import script from "./module-skeleton.vue?vue&type=script&lang=ts&setup=true&"
export * from "./module-skeleton.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./module-skeleton.vue?vue&type=style&index=0&id=2e7f7d9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f7d9e",
  null
  
)

export default component.exports